

















































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext,
  reactive
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import SnackBar from "../../../Common/SnackBar.vue";
import RealTimeTransferKey from "@/components/real-time-transfer-key";
import { bankAccountNoCheck } from "@/methods/validation";
import router from "@/router/index";
import SnackbarKey from "@/components/snackbar-key";

interface SnackBar {
  [prop: string]: any;
}

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);
    const member = computed(() => memberStore.member);

    const accountFirstName = ref<string>("");
    const accountLastName = ref<string>("");

    const searchBranchName = computed(
      () => realTimeTransferStore.searchBranchName
    );
    const bankCodeBankingFacilitiesBranchList = computed(
      () => realTimeTransferStore.bankCodeBankingFacilitiesBranchList
    );
    const selectBankInfos = computed(
      () => realTimeTransferStore.selectBankInfos
    );
    const selectBranchInfos = computed(
      () => realTimeTransferStore.selectBranchInfos
    );
    const selectAccount = computed(() => realTimeTransferStore.selectAccount);
    const accountNumber = computed(() => realTimeTransferStore.accountNumber);
    const menuPage = computed(() => realTimeTransferStore.menuPage);
    // 登録ボタン押下後のスナックバー制御
    const snackbar = reactive<SnackBar>({
      display: false,
      error: false,
      message: ""
    });
    // storeを注入
    const snackbarStore = inject(SnackbarKey);
    if (!snackbarStore) {
      throw new Error(`${snackbarStore} is not provided`);
    }

    // 入金側の預金種目 (1:普通、2:当座、4:貯蓄、9:その他) 　楽天銀行は(1:普通)のみ
    const accountType = [
      {
        id: 1,
        name: "普通"
      },
      {
        id: 2,
        name: "当座"
      },
      {
        id: 4,
        name: "貯蓄"
      }
    ];

    const setSelectBranchInfos = (e: any) => {
      realTimeTransferStore.setSelectBranchInfos(e);
    };

    // 半角カナから全角カナへの変換
    const halfWidthToFullWidth = (e: string) => {
      let kanaMap: any = {
        ｶﾞ: "ガ",
        ｷﾞ: "ギ",
        ｸﾞ: "グ",
        ｹﾞ: "ゲ",
        ｺﾞ: "ゴ",
        ｻﾞ: "ザ",
        ｼﾞ: "ジ",
        ｽﾞ: "ズ",
        ｾﾞ: "ゼ",
        ｿﾞ: "ゾ",
        ﾀﾞ: "ダ",
        ﾁﾞ: "ヂ",
        ﾂﾞ: "ヅ",
        ﾃﾞ: "デ",
        ﾄﾞ: "ド",
        ﾊﾞ: "バ",
        ﾋﾞ: "ビ",
        ﾌﾞ: "ブ",
        ﾍﾞ: "ベ",
        ﾎﾞ: "ボ",
        ﾊﾟ: "パ",
        ﾋﾟ: "ピ",
        ﾌﾟ: "プ",
        ﾍﾟ: "ペ",
        ﾎﾟ: "ポ",
        ｳﾞ: "ヴ",
        ﾜﾞ: "ヷ",
        ｦﾞ: "ヺ",
        ｱ: "ア",
        ｲ: "イ",
        ｳ: "ウ",
        ｴ: "エ",
        ｵ: "オ",
        ｶ: "カ",
        ｷ: "キ",
        ｸ: "ク",
        ｹ: "ケ",
        ｺ: "コ",
        ｻ: "サ",
        ｼ: "シ",
        ｽ: "ス",
        ｾ: "セ",
        ｿ: "ソ",
        ﾀ: "タ",
        ﾁ: "チ",
        ﾂ: "ツ",
        ﾃ: "テ",
        ﾄ: "ト",
        ﾅ: "ナ",
        ﾆ: "ニ",
        ﾇ: "ヌ",
        ﾈ: "ネ",
        ﾉ: "ノ",
        ﾊ: "ハ",
        ﾋ: "ヒ",
        ﾌ: "フ",
        ﾍ: "ヘ",
        ﾎ: "ホ",
        ﾏ: "マ",
        ﾐ: "ミ",
        ﾑ: "ム",
        ﾒ: "メ",
        ﾓ: "モ",
        ﾔ: "ヤ",
        ﾕ: "ユ",
        ﾖ: "ヨ",
        ﾗ: "ラ",
        ﾘ: "リ",
        ﾙ: "ル",
        ﾚ: "レ",
        ﾛ: "ロ",
        ﾜ: "ワ",
        ｦ: "ヲ",
        ﾝ: "ン",
        ｧ: "ァ",
        ｨ: "ィ",
        ｩ: "ゥ",
        ｪ: "ェ",
        ｫ: "ォ",
        ｯ: "ッ",
        ｬ: "ャ",
        ｭ: "ュ",
        ｮ: "ョ",
        "｡": "。",
        "､": "、",
        ｰ: "ー",
        "｢": "「",
        "｣": "」",
        "･": "・",
        " ": "　",
      };

      let reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
      return e
        .replace(reg, function(match) {
          return kanaMap[match];
        })
        .replace(/ﾞ/g, "゛")
        .replace(/ﾟ/g, "゜");
    };
    const memberFirstNameKana = halfWidthToFullWidth(member.value.kana_name_1);
    const memberLastNameKana = halfWidthToFullWidth(member.value.kana_name_2);

    const register = async () => {
      if (bankAccountNoCheck(accountNumber.value)) {
        snackbar.message = "口座番号は七文字以下の半角数字で入力してください";
        snackbar.error = true;
        snackbar.display = true;
        // 2.5秒後にスナックバーを初期化する
        setTimeout(() => {
          snackbar.display = false;
          snackbar.error = false;
          snackbar.message = "";
        }, 2500);
        return;
      }
      if (Number(accountNumber.value) === 0) {
        snackbar.message = "無効な口座番号です";
        snackbar.error = true;
        snackbar.display = true;
        setTimeout(() => {
          snackbar.display = false;
          snackbar.error = false;
          snackbar.message = "";
        }, 2500);
        return;
      }
      if (
        accountFirstName.value !== memberFirstNameKana ||
        accountLastName.value !== memberLastNameKana
      ) {
        snackbar.message = "本人以外の口座には振込できません。";
        snackbar.error = true;
        snackbar.display = true;
        setTimeout(() => {
          snackbar.display = false;
          snackbar.error = false;
          snackbar.message = "";
        }, 2500);
        return;
      }
      // ロード画面表示
      loadedFlag.value = true;

      // 登録押下から3秒後にAPI処理を走らせる
      setTimeout(() => {
        const result = realTimeTransferStore.postBankCodeBankingFacilitiesAccountRegistration(
          String(Math.floor(member.value.member_no))
        );
        result.then(function(value: any) {
          // APIの実行結果に依ってメッセージを変える
          if (value == 201) {
            // 成功メッセージが振込画面で出すのでstoreに値を保存
            const info = {
              message: "振込先口座を追加しました",
              error: false,
              display: true
            };
            snackbarStore.displaySnackbar(info);
            // 成功の場合は銀行振込画面へ遷移
            context.root.$router.push({name: "RealTimeTransferRequestInput"});
          } else if (value == 400) {
            snackbar.message = "同一口座が既に存在します";
            snackbar.error = true;
            snackbar.display = true;
          } else {
            snackbar.message = "振込先口座を追加できませんでした";
            snackbar.error = true;
            snackbar.display = true;
          }
        });
        // API実行結果が返ってきて1秒後にローディング終了
        setTimeout(() => {
          loadedFlag.value = false;
        }, 1000);
        // エラー四秒後：成功二秒後にスナックバーを初期化する
        setTimeout(
          () => {
            snackbar.display = false;
            snackbar.error = false;
            snackbar.message = "";
          },
          snackbar.error ? 4000 : 2500
        );
      }, 3000);
    };

    const setAccountNumber = (e: any) => {
      realTimeTransferStore.setAccountNumber(e);
    };

    const setAccountType = (e: any) => {
      realTimeTransferStore.setAccountType(e);
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      loadedFlag.value = false;
    });

    return {
      loadedFlag,
      bankCodeBankingFacilitiesBranchList,
      searchBranchName,
      selectBranchInfos,
      selectBankInfos,
      selectAccount,
      menuPage,
      accountType,
      accountNumber,
      setAccountType,
      setAccountNumber,
      setSelectBranchInfos,
      register,
      snackbar,
      memberFirstNameKana,
      memberLastNameKana,
      accountFirstName,
      accountLastName
    };
  },
  components: { SnackBar }
});
